var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1F2937"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.35418C16.7329 7.52375 17.8053 7 19 7C21.2091 7 23 8.79086 23 11C23 13.2091 21.2091 15 19 15C17.8053 15 16.7329 14.4762 16 13.6458M19 25H7V24C7 20.6863 9.68629 18 13 18C16.3137 18 19 20.6863 19 24V25ZM19 25H25V24C25 20.6863 22.3137 18 19 18C17.9071 18 16.8825 18.2922 16 18.8027M17 11C17 13.2091 15.2091 15 13 15C10.7909 15 9 13.2091 9 11C9 8.79086 10.7909 7 13 7C15.2091 7 17 8.79086 17 11Z",
    stroke: "#9CA3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiUsers);
export default __webpack_public_path__ + "static/media/aiUsers.bf6fc39fccc07a84e5343d2c5186aff7.svg";
export { ForwardRef as ReactComponent };